import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import React, {useCallback} from 'react';
import {useAppDispatch} from 'src/js/store_hooks';

import {LoginMenu} from './LoginMenu';
import {logout} from '../login_actions';

const LoginMenuContainer = (props) => {
  const {config, stateId} = props;
  const {keycloak} = useKeycloak();
  const dispatch = useAppDispatch();

  const handleLogout = useCallback(() => {
    dispatch(logout(stateId, config.service.url.logout, keycloak));
  }, [config, dispatch, keycloak, stateId]);

  return (
    <LoginMenu
      config={config}
      isLoggedIn={keycloak && keycloak.authenticated}
      handleLogout={handleLogout}
      user={
        keycloak && keycloak.tokenParsed
          ? keycloak.tokenParsed.preferred_username
          : ''
      }
    />
  );
};

LoginMenuContainer.displayName = 'LoginMenuContainer';

LoginMenuContainer.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  stateId: PropTypes.string.isRequired,
};

export default LoginMenuContainer;
